import React from "react"
import TeamMemberMultiselect from "./TeamMemberMultiselect.molecule"
import Label from "../atoms/Label.atom"
import ErrorMessageForm from "../atoms/ErrorMessageForm.atom"
import { hasAnyErrors } from "../../utils/validations.utils"

const TeamMemberMultiselectForm = React.forwardRef((props, ref) => {
  const forId =
    props.id ||
    `teammember-multiselect-${props.label?.replace(/ /g, "-")}-${new Date().getTime()}`
  return (
    <>
      {props.label && (
        <Label htmlFor={forId}>
          {props.label}
          {props.require ? " *" : ""}
          {props.optional ? " (opcional)" : ""}
        </Label>
      )}{" "}
      <TeamMemberMultiselect
        ref={ref}
        id={forId}
        name={props.name}
        value={props.value}
        optionValue={props.optionValue}
        optionLabel={props.optionLabel}
        selectedTeamMembers={props.value}
        setSelectedTeamMembers={props.onChange}
        initiallySelected={props.initiallySelected}
        filterByTeamAreaId={props.filterByTeamAreaId}
      />
      {hasAnyErrors(props.error) ?
        <ErrorMessageForm errorMessage={props.error[0]?.errorMessage} />
      : null}
    </>
  )
})

export default TeamMemberMultiselectForm
